import React, { useContext, useEffect, useState } from 'react';
import { getNavigation } from '#api';

const PagesContext = React.createContext();

const usePages = () => {
    return useContext(PagesContext);
};

const PagesProvider = ({ children }) => {
    const [mainPages, setMainPages] = useState(null);
    const [mainParams, setMainParams] = useState(null);
    const [adminPages, setAdminPages] = useState(null);
    const [adminParams, setAdminParams] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            const MAIN_PAGES = localStorage.getItem('MAIN_PAGES');
            const MAIN_PARAMS = localStorage.getItem('MAIN_PARAMS');
            const ADMIN_PAGES = localStorage.getItem('ADMIN_PAGES');
            const ADMIN_PARAMS = localStorage.getItem('ADMIN_PARAMS');
            const ROUTES_EXPIRE = localStorage.getItem('ROUTES_EXPIRE');

            if (
                MAIN_PAGES &&
                MAIN_PARAMS &&
                ADMIN_PAGES &&
                ADMIN_PARAMS &&
                ROUTES_EXPIRE &&
                Number(ROUTES_EXPIRE) > Date.now()
            ) {
                setMainPages(JSON.parse(MAIN_PAGES));
                setMainParams(JSON.parse(MAIN_PARAMS));
                setAdminPages(JSON.parse(ADMIN_PAGES));
                setAdminParams(JSON.parse(ADMIN_PARAMS));
            } else {
                const result = await getNavigation();
                const json = result.data;

                setMainPages(json.main.pages);
                setMainParams(json.main.params);
                setAdminPages(json.admin.pages);
                setAdminParams(json.admin.params);

                localStorage.setItem('MAIN_PAGES', JSON.stringify(json.main.pages));
                localStorage.setItem('MAIN_PARAMS', JSON.stringify(json.main.params));
                localStorage.setItem('ADMIN_PAGES', JSON.stringify(json.admin.pages));
                localStorage.setItem('ADMIN_PARAMS', JSON.stringify(json.admin.params));
                localStorage.setItem('ROUTES_EXPIRE', Date.now() + 10 * 60 * 60 * 1000); // 10h
            }
            setLoading(false);
        };
        loadData();
    }, []);

    const value = {
        mainPages,
        mainParams,
        adminPages,
        adminParams,
        loading,
    };

    return <PagesContext.Provider value={value}>{children}</PagesContext.Provider>;
};

export { usePages };
export default PagesProvider;
